import { __decorate } from "tslib";
import { Mixins, Component } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import PageTitle from '@/components/v2/PageTitle.vue';
import LinkButton from '@/components/link_button/Index.vue';
import MerchantOrderExport from '@/components/v2/network_distributor/MerchantOrderExport.vue';
import MerchantBillingExport from '@/components/v2/network_distributor/MerchantBillingExport.vue';
let Merchant = class Merchant extends Mixins(ViewportSizeMixin) {
    get merchantUuid() {
        return this.$route.params.merchantUuid;
    }
    get isBilling() {
        return this.$route.name === 'reseller-specific-merchant-billings';
    }
};
Merchant = __decorate([
    Component({
        components: {
            PageTitle,
            LinkButton,
            MerchantOrderExport,
            MerchantBillingExport,
        },
    })
], Merchant);
export default Merchant;
